export const getDurationFromIsoDates = (departure: string, arrival: string) => {
	const difference =
		(new Date(arrival).getTime() - new Date(departure).getTime()) /
		1000 /
		60

	return Math.round(difference)
}

//! @TODO migrate this to libfmt
export const getRemainingTime = (datetime: string): string => {
	const then = new Date(datetime)
	const arrayDate = datetime.split('T')
	const arrayHours = arrayDate[1].split(':')
	const now = new Date()
	const difference = then.getTime() - now.getTime()
	const result = Math.floor(difference / (1000 * 60))
	if (result > 60) {
		return arrayHours[0] + 'h' + arrayHours[1]
	} else return result + ''
}
